import React, { FC } from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay'

import { Metadata } from '@components'
import {
  H2,
  SponsorsSection,
  Grid,
  Card,
  H3,
  Paragraph,
  Strong,
  Screen,
} from '@newComponents'
import { YStack, useMedia } from 'tamagui'

import { EventsScreenList } from './EventsScreenList'

import { EventsScreenQuery } from './__generated__/EventsScreenQuery.graphql'

export const EventsScreen: FC = () => {
  const data = useLazyLoadQuery<EventsScreenQuery>(
    graphql`
      query EventsScreenQuery {
        ...EventsScreenList_query

        ...SponsorsSection_query
      }
    `,
    {}
  )

  return (
    <>
      <Metadata title='Upcoming Events' />

      <Screen>
        <YStack gap={100} $gtMd={{ display: 'none' }}>
          <YStack gap='$6'>
            <H2>Upcoming Events</H2>

            <EventsScreenList query={data} />
          </YStack>

          <SponsorsSection query={data} />
        </YStack>

        <Grid gap='$8' display='none' $gtMd={{ display: 'flex' }}>
          <Grid.Column gap='$6' flexGrow={2} $gtMd={{ flexGrow: 3 }}>
            <H2>Upcoming Events</H2>

            <EventsScreenList query={data} />
          </Grid.Column>

          <Grid.Column gap='$4' flexGrow={1}>
            <YStack gap='$4' style={{ position: 'sticky', top: 188.8671875 }}>
              <Card
                gap='$4'
                $gtMdHt={{ display: 'flex' }}
                $mdHt={{ display: 'none' }}
              >
                <Paragraph size='$4' color='$grey8'>
                  Hang out with your friends, make new ones, and discover new
                  topics together 💖
                </Paragraph>

                <Paragraph size='$4' color='$grey8'>
                  Thanks to our sponsors for making it possible 👇
                </Paragraph>
              </Card>

              <SponsorsSection query={data} />
            </YStack>
          </Grid.Column>
        </Grid>
      </Screen>
    </>
  )
}

export default EventsScreen
